import React from 'react';
import { number, string, bool, shape, func } from 'prop-types';
import { scriptPropType } from '@bbc/gel-foundations/prop-types';
import Timestamp from '@bbc/psammead-timestamp';
import { isValidDateTime, formatUnixTimestamp, localisedMoment } from './utilities';

var TimestampContainer = function TimestampContainer(_ref) {
  var timestamp = _ref.timestamp,
      dateTimeFormat = _ref.dateTimeFormat,
      format = _ref.format,
      isRelative = _ref.isRelative,
      padding = _ref.padding,
      prefix = _ref.prefix,
      suffix = _ref.suffix,
      timezone = _ref.timezone,
      script = _ref.script,
      locale = _ref.locale,
      service = _ref.service,
      altCalendar = _ref.altCalendar;
  var altDateTime;

  if (!isValidDateTime(new Date(timestamp))) {
    return null;
  }

  var mainDateTime = formatUnixTimestamp({
    timestamp: timestamp,
    format: format,
    timezone: timezone,
    locale: locale,
    isRelative: isRelative
  });

  if (altCalendar && !isRelative) {
    altDateTime = "".concat(altCalendar.formatDate(localisedMoment({
      locale: locale,
      timestamp: timestamp
    })), " -");
  }

  var timestampText = [prefix, altDateTime, mainDateTime, suffix].filter(function (segment) {
    return segment;
  }) // Filter falsy segments.
  .join(' ');
  return /*#__PURE__*/React.createElement(Timestamp, {
    datetime: formatUnixTimestamp({
      format: dateTimeFormat,
      locale: 'en-gb',
      timestamp: timestamp,
      timezone: timezone
    }),
    padding: padding,
    script: script,
    service: service
  }, timestampText);
};

TimestampContainer.propTypes = {
  timestamp: number.isRequired,
  dateTimeFormat: string.isRequired,
  isRelative: bool,
  format: string,
  timezone: string,
  padding: bool,
  prefix: string,
  suffix: string,
  script: shape(scriptPropType).isRequired,
  locale: string,
  service: string.isRequired,
  altCalendar: shape({
    formatDate: func.isRequired
  })
};
TimestampContainer.defaultProps = {
  isRelative: false,
  format: null,
  timezone: 'Europe/London',
  padding: true,
  prefix: null,
  suffix: null,
  locale: 'en-gb',
  altCalendar: null
};
export default TimestampContainer;